import React from "react";
import Chart from "react-apexcharts";

const PercentageView = ({ views, viewedBy }) => {
  let percentage = 0;

  if(views != null && viewedBy != null) {
    percentage = (parseInt(views) / parseInt(viewedBy)) * 100;
  }
  
  let data = {
    options: {
      plotOptions: {
        radialBar: {
          hollow: {
            size: '70%',
          }
        },
      },
      labels: ['Views'],
    },
    series: [percentage.toFixed(2)],
  };

  return (
    <Chart
      options={ data.options }
      series={ data.series }
      type="radialBar"
    />
  );
}

export default PercentageView;